import React,{useEffect} from "react";
import Header from "../pages/inc/Header";
import Footer from "../pages/inc/Footer";
import Banner from "./About/Banner";
import Body from "./About/Body";
import Popmodal from "../pages/inc/popmodal";
import { title } from "framer-motion/client";
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

const Home = () => {
const { t, i18n } = useTranslation();
  const bannerdata = {
      img:"img/about-cfan.jpg",
      titleone:t('About_Us'),
      titletwo:t('About_Us'),
      textone:t('About_title_one'),
      texttwo:t('About_title_two'),
      textthree:t('About_title_three'),
      
    };

    const aboutpeoples = [{
      "img":"Reinhard Bonnke_bgremoved.png",
      "name":t('Reinhard_Bonnke'),
      "title":t('Reinhard_Bonnke_title'),
      "description":t('Evangelist_Reinhard_Bonnke_was_principally'),
      "readmore": "https://cfan.org/reinhard-bonnke",
    },{
      "img":"Daniel Kolenda.jpg",
      "name":t('Daniel_Kolenda'),
      "title":t('Daniel_Kolenda_title'),
      "description":t('Daniel_Kolenda_is_a_missionary_evangelist'),
      "readmore": "https://danielkolenda.com/",
    }];
  const fullsection = {
    text:[t(''),
      [t('the_big_tent'),t('before_long_time')],
      [t('greter_things'),t('mssive_bigtent')], 
      t('infulential_leaders'), 
      t('throughout_life'),
      [t('beyond_africa'),t('ministry_continue')], 
      t('gospel_cruched'), 
      [t('cfan_publication'),t('an_impactful_important')], 
      t('our_emphasis'), 
      t('but_that_all'), 
      [t('passing_the_baton'),t('at_his_farewell')], 
      [t('a_legacy_to_be'),t('on_december_heaven')],
      [t('the_decade_double'),t('the_decade_harvest')], 
      [t('decapolis_other_harvest'),t('operation_decapolis')], 
      [t('further_multiplication'),t('standalone_outeaches')], 
      [t('cfan_collaboration'),t('as_one_mosts')], 
      [t('nations_churches'),t('another_marking_moment')], 
      [t('yet_greater_harvestes'),t('such_the_magnitude')]
    ]
  }
  const therebelivedata = {
    textsone:[{title:t('')},{title:t('')},{title:t('')}],
    textstwo:[{title:t('therebelive_texttwo')},
      {title:t('therebelive_titletwo_2')},
      {title:t('therebelive_titletwo_3')},
      {title:t('therebelive_titletwo_4')},
      {title:[t('the_yellow_tent'),t('therebelive_titletwo_5')]}
    ],
    textthree:t('therebelive_titlethree'),
    imgs:[{img:"img/what-we-are.jpg",alt:"what",class:""},
      {img:"img/waht-we-do.jpg",alt:"what",class:"position-image"}
    ],
  };
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [pathname]); 
  return (   
    <>
    <Header/>
    <Banner bannerdata={bannerdata}/>
    <Body aboutpeoples={aboutpeoples} therebelivedata={therebelivedata} fullsection={fullsection} />
    <Footer/>
    <Popmodal/>
    </>
  );
};

export default Home;